import { SignUp } from "@clerk/clerk-react";

export default function Signup() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#0B0B0C" }}
    >
      <div className="flex flex-col items-center gap-6">
        <div className="flex items-center gap-2">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold text-white"
            style={{ backgroundColor: "#F97316" }}
          >
            C
          </div>
          <span className="text-white font-semibold">Callaloo RFP</span>
        </div>
        <SignUp
          routing="path"
          path="/signup"
          signInUrl="/login"
          forceRedirectUrl="/"
          appearance={{
            variables: {
              colorPrimary: "#F97316",
              colorBackground: "#111318",
              colorText: "#FFFFFF",
              colorInputBackground: "#1F2933",
              colorInputText: "#FFFFFF",
              colorTextSecondary: "#9CA3AF",
            },
          }}
        />
      </div>
    </div>
  );
}
